import * as React from 'react'

function SvgFunClose(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M13.477 12.062l5.355-5.355a.999.999 0 10-1.414-1.414l-5.355 5.355-5.356-5.355a.999.999 0 10-1.414 1.414l5.356 5.355-5.28 5.281a.999.999 0 101.414 1.414l5.28-5.281 5.28 5.281a.997.997 0 001.415 0 .999.999 0 000-1.414l-5.281-5.281z" />
    </svg>
  )
}

export default SvgFunClose
